import React, { useState } from 'react';
import UserForm from './UserForm';
import UserList from './UserList';
import { AnimatedBackground, ModernCard } from './ui/modern';

const UsersPage = ({ user }) => {
  const [showUserForm, setShowUserForm] = useState(false);
  const [refreshCounter, setRefreshCounter] = useState(0);

  if (!user || user.role !== 'Admin') {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gradient-to-br dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 flex items-center justify-center">
        <AnimatedBackground />
        <ModernCard className="text-center">
          <div className="text-6xl mb-4">🔒</div>
          <div className="text-xl text-gray-900 dark:text-white mb-2">Access Denied</div>
          <div className="text-gray-600 dark:text-slate-400">You don't have permission to view this page.</div>
        </ModernCard>
      </div>
    );
  }

  const handleUserCreated = () => {
    setShowUserForm(false);
    setRefreshCounter(c=>c+1);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gradient-to-br dark:from-slate-900 dark:via-slate-800 dark:to-slate-900">
      <AnimatedBackground />
      
      <div className="relative z-10 p-6 lg:p-8 max-w-7xl mx-auto">
        {/* Header */}
        <ModernCard className="mb-8 p-6 bg-gradient-to-r from-blue-100 to-purple-100 dark:from-blue-900/50 dark:to-purple-900/50 border-blue-200 dark:border-blue-500/20">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
            <div>
              <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 dark:text-white mb-2 flex items-center gap-3">
                <span className="text-4xl">👥</span> User Management
              </h1>
              <p className="text-blue-700 dark:text-blue-200 text-sm sm:text-base">Manage system users and their permissions</p>
            </div>
            <button
              onClick={() => setShowUserForm(!showUserForm)}
              className={`
                px-6 py-3 rounded-xl font-bold text-white text-lg
                flex items-center gap-2 shadow-xl
                transition-all duration-300 transform hover:scale-105
                ${showUserForm 
                  ? 'bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 shadow-red-500/50' 
                  : 'bg-gradient-to-r from-green-600 via-blue-600 to-purple-600 hover:from-green-700 hover:via-blue-700 hover:to-purple-700 shadow-blue-500/50 animate-pulse'
                }
              `}
            >
              {showUserForm ? (
                <>
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  Close Form
                </>
              ) : (
                <>
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                  Add New User
                </>
              )}
            </button>
          </div>
        </ModernCard>

        {/* User Form */}
        {showUserForm && (
          <div className="mb-8">
            <UserForm onUserCreated={handleUserCreated} />
          </div>
        )}

        {/* User List */}
        <UserList user={user} refreshSignal={refreshCounter} />
      </div>
    </div>
  );
};

export default UsersPage; 